import { render } from "./AggregatorList.vue?vue&type=template&id=238576f7&scoped=true"
import script from "./AggregatorList.vue?vue&type=script&lang=js"
export * from "./AggregatorList.vue?vue&type=script&lang=js"

import "./AggregatorList.vue?vue&type=style&index=0&id=238576f7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-238576f7"]])

export default __exports__